//const AMBIENTE = 'https://server.basedefutbol.com/baseunica';
const AMBIENTE = 'https://d2x7guex2p6crp.cloudfront.net/baseunica';
export default AMBIENTE;
